import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { fuseAnimations } from '../../../../core/animations';
import { FuseMainComponent } from '../../../main.component';
import { UserService } from '../../services/user.service';
import { AppService } from '../../services/app.service';
import { DashboardService } from '../../services/dashboard.service';
import { ComponentService } from '../../services/component.service';
import { Router } from '@angular/router';
import { FuseNavigationService } from '../../../../core/components/navigation/navigation.service';
import { FuseConfigService } from '../../../../core/services/config.service';
import { debug } from 'util';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MaintainanceComponent } from '../maintainance/maintainance.component';
import { SystemDataService } from '../../services/systemdata.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class DashboardComponent implements OnInit {
  moduleList: any = [];
  MenuItem: any = [];

  dashboardTiles: any = [];
  translations: any = [];
  a : String = "1234567";
  maintainanaceData : {
    MaintainanceActivity: false,
    MaintenanceMessage :'',
    ShowMaintenanceMessage : false
  };
  editFormDialogRef: MatDialogRef<MaintainanceComponent>;
  
  constructor(
    private userService: UserService,
    public appService: AppService,
    public dashService: DashboardService,
    public comService: ComponentService,
    public _router: Router,
    private fuseNavigationService: FuseNavigationService,
    private fuseConfig: FuseConfigService,
    public dialog: MatDialog,
    public sysService : SystemDataService
  ) {

    sessionStorage.setItem('dashStatusId', "0");
    sessionStorage.setItem('dashCountryId', "0");

    this.a = this.a.replace(new RegExp("^(\\d{" + (this.a.length % 3 ? this.a.length % 3 : 0) + "})(\\d{3})", "g"), "$1 $2").replace(/(\d{3})+?/gi, ",$1").trim();

    if (sessionStorage.getItem('authToken') == null) {
      this._router.navigateByUrl('/login')
    }
    this.fuseConfig.setSettings({
      layout: {
        navigation: 'left',
        toolbar: 'below',
        footer: 'below'
      }
    });
    this.checkMaintainance();
  
       
  }
  accessSuccessCallback(): void {
      let e: any = [];
      e.index = 0;
      this.onModuleChange(e);
      
  }

  setPageTranslations() {
    this.comService.get('dashboard').subscribe((res) => {
      this.translations = JSON.parse(res['Data']); 
    });
  }

  accessErrorCallback(error): void {
    this.appService.showDialogue("Permission Denied", error);
  }

  ngOnInit() {
    this.fuseConfig.setSettings({
      layout: {
        navigation: 'left',
        toolbar: 'below',
        footer: 'below'
      }
    });
    this.appService.hideLoading();
    this.selectDashboardTiles(); 
   }

  onModuleChange(e): void {
    this.appService.hideLoading();
    this.fuseNavigationService.getPagesByRoleSuccessCallback();
  }

  selectDashboardTiles(): void {
    this.dashService.selectDashboardTiles().subscribe(
      res => this.selectDashboardTilesSuccess(res),
      error => this.apiFaillure(error)
    );
  }

  selectDashboardTilesSuccess(res): void {
    if (res.Status) {
      debugger
      if (JSON.parse(res.Data).length > 0)
          this.dashboardTiles = JSON.parse(res.Data);
      else 
        this.apiFaillure(this.translations[res.Message]);
    }
  }

  apiFaillure(error): void {
    this.appService.hideLoading();
    this.appService.showDialogue("Error", error.Message);
  }

  showOrdersList(statusId, countryId){
    sessionStorage.setItem('dashStatusId', statusId);
    sessionStorage.setItem('dashCountryId', countryId);
    this._router.navigateByUrl(sessionStorage.getItem('dashboardTileOrderListUrl'));
  }

  formatOrderCount(_number, _sep) {
    _number = typeof _number != "undefined" && _number > 0 ? _number : "0";
    _number = _number.toString().replace(new RegExp("^(\\d{" + (_number.length % 3 ? _number.length % 3 : 0) + "})(\\d{3})", "g"), "$1 $2").replace(/(\d{3})+?/gi, _sep + "$1").trim();
    if(_number.indexOf(' ') > -1) {
        _number = _number.toString().replace(' ', '');
    }
    if(_number.indexOf(',') == 0) {
        _number = _number.substr(1);
    }
    return _number;
  }

  filterTiles(type){
      return this.dashboardTiles.filter(x => x.Type == type).length > 0 ? this.dashboardTiles.filter(x => x.Type == type) : [];
  }

  checkMaintainance(){
    this.sysService.maintainancecheck().subscribe(
      res=> this.checkMaintainanceSuccess(res),
      error=>this.checkMaintainanceFailure(error)
    )
  }
  checkMaintainanceSuccess(res){
    if(res.Status == 1){
      this.maintainanaceData= JSON.parse(res.Data)[0];
      
      if(this.maintainanaceData.MaintainanceActivity.toString() !== "0" 
      && this.maintainanaceData.MaintainanceActivity){
        this.editFormDialogRef = this.dialog.open(MaintainanceComponent, {
          disableClose: true,
          data: {
            MaintenanceMessage : this.maintainanaceData.MaintenanceMessage
          },
          panelClass: 'my-dialog'
        });
        this.editFormDialogRef.afterClosed().subscribe((response) => {
          this.ngOnInit();
        });
      }
      else{
        if(this.maintainanaceData.ShowMaintenanceMessage.toString() == '1'){
          this.editFormDialogRef = this.dialog.open(MaintainanceComponent, {
            disableClose: true,
            data: {
              MaintenanceMessage : this.maintainanaceData.MaintenanceMessage
            },
            panelClass: 'my-dialog'
          });
        }
        else{
        this.accessSuccessCallback();
        this.setPageTranslations();
        }
      }
    }
    else{
      this.accessSuccessCallback();
      this.setPageTranslations();
    }

  }
  checkMaintainanceFailure(error){
    this.accessSuccessCallback();
    this.setPageTranslations();
  }
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/dashboard/dashboard.component.ts